import { ArrowBack } from "@material-ui/icons";
import { Box, IconButton, Typography } from "@mui/material";
import React from "react";
import { useHistory } from "react-router-dom";

const GoBack = ({ title }) => {
  const history = useHistory();
  return (
    <Box display={"flex"} alignItems={"center"}>
      <IconButton size="small" onClick={() => history.goBack()}>
        <ArrowBack />
      </IconButton>
      {title && <Typography variant="body1">{title}</Typography>}
    </Box>
  );
};

export default GoBack;
